"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkRefresh = exports.setTokens = void 0;
const cookieManager_1 = require("../utils/cookieManager");
const config_1 = require("../utils/config");
const refreshToken_1 = require("./refreshToken");
const jwtDecoder_1 = require("../utils/jwtDecoder");
const eventManager_1 = require("../utils/eventManager");
const session_1 = require("./apis/session");
const js_cookie_1 = require("js-cookie");
const broadcastChannel_1 = require("../utils/broadcastChannel");
const a_second = 1000;
let handle;
function setTokens(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const { idToken, accessToken, callInitSession, broadcast = true, authActionType } = args;
        const domain = config_1.getCookieDomain();
        if (domain) {
            cookieManager_1.setLocalCookies({
                idToken,
                accessToken,
            }, domain);
        }
        const decodedIdToken = jwtDecoder_1.getDecodedToken(idToken);
        checkRefresh(accessToken);
        if (callInitSession && !config_1.isAltAuthgateUrl()) {
            yield session_1.initSession(idToken, accessToken, decodedIdToken.email);
        }
        eventManager_1.emit('tokens', {
            idToken,
            accessToken,
        }, authActionType);
        if (broadcast && broadcastChannel_1.getBroadcastChannel() !== null) {
            broadcastChannel_1.getBroadcastChannel().postMessage({ action: 'setTokens', payload: { idToken, accessToken } });
        }
    });
}
exports.setTokens = setTokens;
function checkCookies() {
    if (!js_cookie_1.get('id_token')) {
        eventManager_1.emit('logout.success');
        return false;
    }
    return true;
}
function checkRefresh(access_token) {
    var _a;
    const exp = (_a = jwtDecoder_1.getDecodedToken(access_token || js_cookie_1.get('access_token'))) === null || _a === void 0 ? void 0 : _a.exp;
    const rnd = Math.floor(Math.random() * 15);
    clearTimeout(handle);
    if (!exp) {
        if (checkCookies()) {
            refreshToken_1.refreshToken();
        }
        return;
    }
    const now = Date.now();
    const diff = exp - now / 1000;
    if (diff < 120) {
        handle = setTimeout(refreshToken_1.refreshToken, rnd * 10); // calls refresh if diff is in the last 2 minutes before exp
    }
    else {
        // since when chrome pauses timers on standby, we need to check more frequently rather than use the token's expiry
        // as an indicator
        handle = setTimeout(checkRefresh, (30 + rnd) * a_second); // calls checkRefresh every 30s
    }
}
exports.checkRefresh = checkRefresh;
